import * as Yup from 'yup';
import moment from 'moment';
import checkoutFormModel from './checkoutFormModel';
const {
  formField: {
    firstName,
    lastName,
    file1Name,
    isForeigner,
    file3Name,
    address1,
    city,
    zipcode,
    country,
    nameOnCard,
    cardNumber,
    cvv,
  },
} = checkoutFormModel;

const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

export default [
  Yup.object().shape({
    [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`),
    [lastName.name]: Yup.string().required(`${lastName.requiredErrorMsg}`),
    // [file1Name.name]: Yup.array().min(1, 'select at least 1 file'),
    // [file1Name.name]: Yup.array().min(1),
    [file1Name.name]: Yup.mixed().required('File is required'),
    // https://codeboosh.com/how-to-do-conditional-validation-with-formik-and-yup/
    [isForeigner.name]: Yup.string('isForeigner set Y'),
    [file3Name.name]: Yup.mixed().when([isForeigner.name], {
      is: (test) => test == 'Y',
      then: Yup.mixed().required('File is required'),
    }),
    // [address1.name]: Yup.string().required(`${address1.requiredErrorMsg}`),
    // [city.name]: Yup.string().nullable().required(`${city.requiredErrorMsg}`),
    // [zipcode.name]: Yup.string()
    //   .required(`${zipcode.requiredErrorMsg}`)
    //   .test(
    //     'len',
    //     `${zipcode.invalidErrorMsg}`,
    //     (val) => val && val.length === 5
    //   ),
    // [country.name]: Yup.string()
    //   .nullable()
    //   .required(`${country.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    // [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`),
    // [lastName.name]: Yup.string().required(`${lastName.requiredErrorMsg}`),
    [address1.name]: Yup.string().required(`${address1.requiredErrorMsg}`),
    // [city.name]: Yup.string().nullable().required(`${city.requiredErrorMsg}`),
    // [zipcode.name]: Yup.string()
    //   .required(`${zipcode.requiredErrorMsg}`)
    //   .test(
    //     'len',
    //     `${zipcode.invalidErrorMsg}`,
    //     (val) => val && val.length === 5
    //   ),
    // [country.name]: Yup.string()
    //   .nullable()
    //   .required(`${country.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    [nameOnCard.name]: Yup.string().required(`${nameOnCard.requiredErrorMsg}`),
    // [cardNumber.name]: Yup.string()
    //   .required(`${cardNumber.requiredErrorMsg}`)
    //   .matches(visaRegEx, cardNumber.invalidErrorMsg),
    [cardNumber.name]: Yup.string().required(`${cardNumber.requiredErrorMsg}`),
    // [expiryDate.name]: Yup.string()
    //   .nullable()
    //   .required(`${expiryDate.requiredErrorMsg}`)
    //   .test('expDate', expiryDate.invalidErrorMsg, val => {
    //     if (val) {
    //       const startDate = new Date();
    //       const endDate = new Date(2050, 12, 31);
    //       if (moment(val, moment.ISO_8601).isValid()) {
    //         return moment(val).isBetween(startDate, endDate);
    //       }
    //       return false;
    //     }
    //     return false;
    //   }),
    // [cvv.name]: Yup.string()
    //   .required(`${cvv.requiredErrorMsg}`)
    //   .test('len', `${cvv.invalidErrorMsg}`, (val) => val && val.length === 3),
  }),
];
